import {
  EscalationAssignedNotificationInterface,
  EscalationInterface,
  NoteInterface,
  NotificationBaseInterface,
  NotificationInterface,
  NotificationType,
  OrgInterface,
} from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

// LINK apps/server/src/API/Notes/Notes.Controller.ts
export class NotesAPI {
  static async createOrUpdateNote(orgId: number, userId: number, updateExistingNote: boolean, note: Partial<NoteInterface>): Promise<NoteInterface> {
    return APIService.Server.post<NoteInterface>(`/notes/org/${orgId}/user/${userId}/note`, { note, updateExistingNote });
  }

  static async postNoteToFMS(orgId: number, userId: number, note: Partial<NoteInterface>): Promise<void> {
    return APIService.Server.post(`/notes/org/${orgId}/user/${userId}/note`, { note });
  }

  //   static async create(orgId: number, notification: Partial<NotificationBaseInterface>): Promise<NotificationBaseInterface> {
  //     // return APIService.Server.post<NotificationBaseInterface>(`/notifications/org/${orgId}/notification`, { notification });
  //   }
}
